import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { filter, firstValueFrom, Subject, takeUntil } from 'rxjs';

import { PermissionService } from '@services/permissions.service';
import { UserService } from '@services/user.service';
import { GlobalService } from '@services/global.service';
import { SetupInfo } from '@models/setup-info';
import { Language } from '@models/language';
import { LanguageSyncService } from '@services/language-sync.service';
import { environment } from '@environment';

@Component({
    selector: 'cp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    isIframe: boolean = window !== window.parent && !window.opener;

    private readonly _destroying$: Subject<void> = new Subject<void>();

    setupInfo: SetupInfo[] = [];

    constructor(
        private _authService: MsalService,
        private _permissionService: PermissionService,
        private _userService: UserService,
        private _router: Router,
        private _msalBroadcastService: MsalBroadcastService
    ) {
        effect(() => {
            this.setupInfo = this._userService.SetupInfoItems$();
        });
    }

    async ngOnInit() {
        if (!this.isIframe) {
            this.changeFavicon(`assets/icons/favicon-${environment.System}.png`)

            await firstValueFrom(this._authService.initialize()).then();

            const language = localStorage.getItem('currentLanguageId');
            if (language === null || language === undefined) {
                localStorage.setItem('currentLanguageId', navigator.language);
            }

            this._msalBroadcastService.msalSubject$
                .pipe(filter((msg: EventMessage) => (msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)),
                    takeUntil(this._destroying$))
                .subscribe((msg: EventMessage) => {
                    const result: AuthenticationResult = msg.payload as AuthenticationResult;
                    this.SetupUser(result);
                });

            var user = this._userService.getCurrentUser();
            if (user) {
                var isLoggedIn = await firstValueFrom(this._permissionService.isLoggedIn());
                if (isLoggedIn) {
                    // user is present w/ valid token
console.log('User is logged in w valid token');
                    user.Token = localStorage.getItem('token');
                    this._userService.setCurrentUser(user);
                } else {
console.log('User is logged in w invalid token');
                    // user is present w/ invalid token, try to get refreshed token
                    if (await this._userService.isInternalDomain(user.UserId)) {
                        // internal user - try to get refreshed token
console.log('User is logged in w invalid token - internal domain, try to refresh token');
                        await this._userService.loginAuthenticatedUser().then();
                    } else {
                        // external user - force login
                        await this._userService.signOutUser();
                        this._router.navigate(['login']);
                    }
                }
            } else {
                // no user
                // this._router.navigate(['login']);
            }
        }
    }

    ngOnDestroy(): void {
        this._destroying$.next(null);
        this._destroying$.complete();
    }

    private async SetupUser(result: AuthenticationResult): Promise<void> {
        await this._userService.setInternalAccount(result.account, result.idToken);
        this._router.navigate(['home']);
    }

    private changeFavicon(iconUrl: string) {
        const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
        if (link) {
            link.href = iconUrl;
        }
    }
}
